import styled, { css } from 'styled-components'

import { device } from '~/styles/device'

/**
 * Três colunas no largo, como `#screen-adm-review .review-info-grid` no
 * protótipo do offsite, caindo para duas e depois uma conforme aperta.
 *
 * Os degraus são os tokens de `device`, os mesmos que a grade do `Budget` usa.
 * Herdamos daqui um `max-width: 900px` cru, que vinha do `BriefingRows`: o
 * número não existia em lugar nenhum além daquela regra, e duas grades que
 * pretendem espelhar o mesmo desenho quebrando em larguras diferentes é
 * divergência esperando para aparecer.
 */
export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--sl-space-5) var(--sl-space-8);

  @media ${device.tablet} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media ${device.laptop} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`

export const Item = styled.dl<{ $wide?: boolean }>`
  ${({ $wide }) => css`
    margin: 0;
    min-width: 0;

    ${$wide &&
    css`
      grid-column: 1 / -1;
    `}

    dt {
      font: var(--sl-text-caption-1-font);
      color: var(--sl-fg-base-soft);
    }

    dd {
      margin: var(--sl-space-1) 0 0;

      font: var(--sl-text-emphasis-font);
      color: var(--sl-fg-base);
    }
  `}
`
